import * as React from 'react';
import { HomePageContent } from "../HomePageContent/HomePageContent";
import BomListingHeader from "./BomListing/BomListingHeader/BomListingHeader";
import System from 'src/helper/system';

export function BomProductListing() {
    const c = System.getParams();
    const { translation: t } = System;
    return (
        <>
            <BomListingHeader isBomPLP={true} />
            {c?.addFrom === 'BomSearchMatch' && (
                <div className="container mt-3 mb-4">
                    <div className="bs5 bg-gray4 darkgray-border p-2 rounded-3 text-center font-16 font-arial">
                        <strong>
                            {c.search && <>{t('youSearchedFor')} {c.search}{t('addToBOMFromResultsBelow')}</>}
                        </strong>
                    </div>
                </div>)}

            <HomePageContent isBomPLP={true} />
        </>
    );

}
